const sizeConfigs = {
  sidebar: {
    width: "270px"
  }
};

export default sizeConfigs;